import React from 'react'

const IconSocialYoutube = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140">
		<path d="M140 40a25 25 0 0 0-25-25H25A25 25 0 0 0 0 40v60a25 25 0 0 0 25 25h90a25 25 0 0 0 25-25ZM95.7 76.2 63.6 94.1a7.2 7.2 0 0 1-7.1 0A6.9 6.9 0 0 1 53 88V52.1a6.9 6.9 0 0 1 3.5-6.1 7.2 7.2 0 0 1 7.1 0l32.1 17.8a7 7 0 0 1 0 12.4Z" />
	</svg>
)

export default IconSocialYoutube
